import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_USER_EKYC_RECORDS_API_ID =
  'FETCH_INVESTCORE_USER_EKYC_RECORDS_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_EKYC_RECORDS_API_ID,
  ({ userId, ...params }: { userId: string; [key: string]: any }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/user-ekyc-records`,
      params: { ...params, user_id: userId },
    }),
    method: 'GET',
  })
);

export default apiCall;
